export const commentsTableHeaders = [
    "Fecha",
    "Radicado",
    "Tipo Inv.",
    "Abogado",
    "Cliente",
    "Detalles",
    "Comentarios"
];

export const commentsTableBody = [
    {
        data: "formattedDate",
        classname: "inline-text"
    },
    {
        data: "filingNumber",
        classname: "inline-text"
    },
    {
        data: "caseType",
        classname: ""
    },
    {
        data: "attorneyText",
        classname: ""
    },
    {
        data: "clientText",
        classname: ""
    },
    {
        data: "details",
        classname: ""
    },
    {
        data: "commentsText",
        classname: ""
    }
];